/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_New_ChatInputs */

const en_mcp_demo_new_chat = /** @type {(inputs: Mcp_Demo_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New chat`)
};

const es_mcp_demo_new_chat = /** @type {(inputs: Mcp_Demo_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo chat`)
};

/**
* | output |
* | --- |
* | "New chat" |
*
* @param {Mcp_Demo_New_ChatInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_new_chat = /** @type {((inputs?: Mcp_Demo_New_ChatInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_New_ChatInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_new_chat(inputs)
	return en_mcp_demo_new_chat(inputs)
});